import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EducationService } from 'src/app/_services/education.service';
import { AdminService } from './../../../_services/admin.service';
declare var $;
@Component({
  selector: 'app-show-country',
  templateUrl: './show-country.component.html',
  styleUrls: ['./show-country.component.css']
})
export class ShowCountryComponent implements OnInit {
  country=undefined
  loading =true
  levelList=undefined
  server_country_id=0
  constructor(private adminService:AdminService, private activatedRoute: ActivatedRoute, private educationService:EducationService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      val=>{
        this.server_country_id=val['server_country_id']
        if(this.server_country_id!=0){
          this.adminService.getCountry(this.server_country_id).subscribe(
            myC=>{
              this.country=myC
              this.levelList=this.country['levels']
              this.loading=false
            }
          )
        }
      }
    )

  }
  closeLevelModal(){
    $("#modalAddLevelToEducationSystem").modal("hide");
  }

  saveAddLevel(levelData:string){
    this.educationService.addLevel(levelData).subscribe(
      data=>{
        this.country=data
        this.levelList=this.country['levels']
      }
    )
  }

  addLevelPopUp(){
    $("#modalAddLevelToEducationSystem").modal("show");
  }
}
